import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-post-plateform-comments',
  templateUrl: './post-plateform-comments.component.html',
  styleUrls: ['./post-plateform-comments.component.scss']
})
export class PostPlateformCommentsComponent {
  @Input() data: any = null;
  @Input() isPostOnOnePage: boolean = false
  @Input() linkedinPages: any[] = [];
  @Input() platform: string= ""
  @Input() isCommentsLoading: boolean = false
  @Output() itemSelected = new EventEmitter<any>();
  comments: any[] = [];
  pageName: string = ""
  constructor(private sanitizer: DomSanitizer) {}
	@Input() currentComment:any = null;
	environment = environment

	ngOnInit() {
		this.setFirstComment();
	}

	ngOnChanges(changes: SimpleChanges) {
    // if (changes['data'] && this.data.comments.length > 0) {
    //   this.comments = this.data.comments
    //   this.pageName = this.data.name
    // }
  }

	setFirstComment() {
    this.currentComment = this.data.comments[0];
    // Trigger the reply logic for the first comment if needed
    this.reply(this.currentComment);
  }

  reply(item: any){

    if (this.isCommentsLoading) return;
    this.itemSelected.emit({currentComment: item, page: this.data});
    this.currentComment = item;
  }

  getSRCByPlatform(){
    if (this.platform == 'all') return "";
    return "assets/img/simple-logo-" + this.platform + ".png"
  }

  
  formatCommentTime(time:string){
    let x = new Date(time)
    return x.getDate().toString().padStart(2,'0')+"/"+(x.getMonth()+1).toString().padStart(2,'0') +"/"+   x.getFullYear() +" - "+x.getHours().toString().padStart(2,'0') +":"+x.getMinutes().toString().padStart(2,'0')
  }
  renderLikeIconHTML(){
    let iconHTML: string;

    switch (this.platform) {
      case 'facebook':
        iconHTML = `
         <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" xml:space="preserve" width="20px" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;} .st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:5.2066,0;} </style> <path class="st0" d="M11,24V14H5v12h6v-2.4l0,0c1.5,1.6,4.1,2.4,6.2,2.4h6.5c1.1,0,2.1-0.8,2.3-2l1.5-8.6c0.3-1.5-0.9-2.4-2.3-2.4 H20V6.4C20,5.1,18.7,4,17.4,4h0C16.1,4,15,5.1,15,6.4v0c0,1.6-0.5,3.1-1.4,4.4L11,13.8"></path> </g></svg>`;
        break;

      case 'linkedin':
        iconHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" fill="currentColor">
            <path d="M19.46 11l-3.91-3.91a7 7 0 01-1.69-2.74l-.49-1.47A2.76 2.76 0 0010.76 1 2.75 2.75 0 008 3.74v1.12a9.19 9.19 0 00.46 2.85L8.89 9H4.12A2.12 2.12 0 002 11.12a2.16 2.16 0 00.92 1.76A2.11 2.11 0 002 14.62a2.14 2.14 0 001.28 2 2 2 0 00-.28 1 2.12 2.12 0 002 2.12v.14A2.12 2.12 0 007.12 22h7.49a8.08 8.08 0 003.58-.84l.31-.16H21V11zM19 19h-1l-.73.37a6.14 6.14 0 01-2.69.63H7.72a1 1 0 01-1-.72l-.25-.87-.85-.41A1 1 0 015 17l.17-1-.76-.74A1 1 0 014.27 14l.66-1.09-.73-1.1a.49.49 0 01.08-.7.48.48 0 01.34-.11h7.05l-1.31-3.92A7 7 0 0110 4.86V3.75a.77.77 0 01.75-.75.75.75 0 01.71.51L12 5a9 9 0 002.13 3.5l4.5 4.5H19z"></path>
          </svg>`;
        break;
        case 'instagram':
          iconHTML = `
            <svg width="20px"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.00019C10.2006 3.90317 7.19377 3.2551 4.93923 5.17534C2.68468 7.09558 2.36727 10.3061 4.13778 12.5772C5.60984 14.4654 10.0648 18.4479 11.5249 19.7369C11.6882 19.8811 11.7699 19.9532 11.8652 19.9815C11.9483 20.0062 12.0393 20.0062 12.1225 19.9815C12.2178 19.9532 12.2994 19.8811 12.4628 19.7369C13.9229 18.4479 18.3778 14.4654 19.8499 12.5772C21.6204 10.3061 21.3417 7.07538 19.0484 5.17534C16.7551 3.2753 13.7994 3.90317 12 6.00019Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`;
          break;

      default:
        iconHTML = 'no platform provided';
    }

    // Mark the HTML as safe
    return this.sanitizer.bypassSecurityTrustHtml(iconHTML);
    
  }

  renderReplyIconHTML(){
    let iconHTML: string;

    switch (this.platform) {
      case 'facebook':
        iconHTML = `
         <svg width="18px"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1266 22.1995C16.7081 22.5979 17.4463 23.0228 18.3121 23.3511C19.9903 23.9874 21.244 24.0245 21.8236 23.9917C23.1167 23.9184 23.2907 23.0987 22.5972 22.0816C21.8054 20.9202 21.0425 19.6077 21.1179 18.1551C22.306 16.3983 23 14.2788 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C13.4578 23 14.8513 22.7159 16.1266 22.1995ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C13.3697 21 14.6654 20.6947 15.825 20.1494C16.1635 19.9902 16.5626 20.0332 16.8594 20.261C17.3824 20.6624 18.1239 21.1407 19.0212 21.481C19.4111 21.6288 19.7674 21.7356 20.0856 21.8123C19.7532 21.2051 19.4167 20.4818 19.2616 19.8011C19.1018 19.0998 18.8622 17.8782 19.328 17.2262C20.3808 15.7531 21 13.9503 21 12C21 7.02944 16.9706 3 12 3Z" fill="currentColor"></path> </g></svg>`;
        break;

      case 'linkedin':
        iconHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="20px" id="comment-small" aria-hidden="true" role="none" data-supported-dps="16x16" fill="currentColor" focusable="false" class="social-action-bar__icon--svg lazy-loaded" aria-busy="false">
						<path d="M5 8h5v1H5zm11-.5v.08a6 6 0 01-2.75 5L8 16v-3H5.5A5.51 5.51 0 010 7.5 5.62 5.62 0 015.74 2h4.76A5.5 5.5 0 0116 7.5zm-2 0A3.5 3.5 0 0010.5 4H5.74A3.62 3.62 0 002 7.5 3.53 3.53 0 005.5 11H10v1.33l2.17-1.39A4 4 0 0014 7.58zM5 7h6V6H5z"></path>
					</svg>`;
        break;
        case 'instagram':
          iconHTML = `
            <svg width="18px"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1266 22.1995C16.7081 22.5979 17.4463 23.0228 18.3121 23.3511C19.9903 23.9874 21.244 24.0245 21.8236 23.9917C23.1167 23.9184 23.2907 23.0987 22.5972 22.0816C21.8054 20.9202 21.0425 19.6077 21.1179 18.1551C22.306 16.3983 23 14.2788 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C13.4578 23 14.8513 22.7159 16.1266 22.1995ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C13.3697 21 14.6654 20.6947 15.825 20.1494C16.1635 19.9902 16.5626 20.0332 16.8594 20.261C17.3824 20.6624 18.1239 21.1407 19.0212 21.481C19.4111 21.6288 19.7674 21.7356 20.0856 21.8123C19.7532 21.2051 19.4167 20.4818 19.2616 19.8011C19.1018 19.0998 18.8622 17.8782 19.328 17.2262C20.3808 15.7531 21 13.9503 21 12C21 7.02944 16.9706 3 12 3Z" fill="currentColor"></path> </g></svg>`;
          break;

      default:
        iconHTML = 'no platform provided';
    }

    // Mark the HTML as safe
    return this.sanitizer.bypassSecurityTrustHtml(iconHTML);
    
  }

	postAvatarFt(post:any): string | null {
		if (post.avatar) return post.avatar;
	
		if (post.isCommentByPage && this.data?.pageLogoUrl) {
			return this.data.pageLogoUrl;
		}
	
		return null;
	}
}
